/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_CurrencyInputs */

const en_mk_price_currency = /** @type {(inputs: Mk_Price_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing currency`)
};

const id_mk_price_currency = /** @type {(inputs: Mk_Price_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mata uang harga`)
};

/**
* | output |
* | --- |
* | "Pricing currency" |
*
* @param {Mk_Price_CurrencyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_currency = /** @type {((inputs?: Mk_Price_CurrencyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_CurrencyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_currency(inputs)
	return en_mk_price_currency(inputs)
});